import type { MemoizedFunction } from 'lodash';

export const clearMemoizedFunction = (memoizedFunction: MemoizedFunction) => {
  if (memoizedFunction.cache && typeof memoizedFunction.cache.clear === 'function') {
    memoizedFunction.cache.clear();
  }
};
